import 'angular:locale/data:la';
import 'angular:locale/data:sv';
import 'angular:locale/data:nl-NL';
import 'angular:locale/data:da';
import 'angular:locale/data:tr';
import 'angular:locale/data:it';
import 'angular:locale/data:fr';
import 'angular:locale/data:en-GB';
import 'angular:locale/data:es';
import 'angular:locale/data:de';
import 'angular:locale/data:en-US';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
